export const storeDataInLocalStorage = (
  storageKey: string,
  data: string | number | boolean | object | number[] | string[]
) => {
  const valueToStore =
    typeof data === 'object' && data !== null
      ? JSON.stringify(data)
      : String(data);

  localStorage.setItem(storageKey, valueToStore);
};

export const readFromLocalStorage = (storageKey: string): string | null => {
  return localStorage.getItem(storageKey);
};

export const readObjectFromLocalStorage = (
  storageKey: string
): object | null => {
  const data = readFromLocalStorage(storageKey);

  if (!data) {
    return null;
  }

  return JSON.parse(data);
};
